import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listAlertsService } from "../services/listAlerts.service";

export const useAlertsQuery = (filters) => {
  const fetchData = useFetch();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchAlerts = async () => {
      setLoading(true);
      try {
        const listAlerts = listAlertsService(fetchData);
        const response = await listAlerts(filters);
        const data = response.data || [];
        // Orden: más vencidos primero, luego los más próximos a vencer,
        // y por último los que faltan más días (fecha ascendente).
        const sorted = [...data].sort((a, b) => {
          const ta = a?.date ? new Date(a.date).getTime() : Number.POSITIVE_INFINITY;
          const tb = b?.date ? new Date(b.date).getTime() : Number.POSITIVE_INFINITY;
          return ta - tb;
        });
        setAlerts(sorted);
      } catch (error) {
        console.error("Error fetching alerts:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchAlerts, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters]);

  return { alerts, loading, refresh: () => setRefresh((prev) => !prev) };
};
